import { render } from "./edit-kategori.vue?vue&type=template&id=3c5d5b64&scoped=true"
import script from "./edit-kategori.vue?vue&type=script&lang=js"
export * from "./edit-kategori.vue?vue&type=script&lang=js"

import "./edit-kategori.vue?vue&type=style&index=0&id=3c5d5b64&scoped=true&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5d5b64"]])

export default __exports__